import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './table.scss'
import Dropdown from 'react-dropdown';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import './datepicker.scss'
import clientDevices from './../../../API/Client/GetDevices'
import clientBusinessPremises from './../../../API/Client/BusinessPremises'
import logout from './../../../Global/logout'
import checkJwt from './../../../Global/jwtChecker'
import { AiOutlineSearch } from 'react-icons/ai'
import clientInvoices from './../../../API/Client/GetInvoices'
import hr from 'date-fns/locale/hr';

export class Search extends React.Component{
    state={
        listNapUredOption: [],
        listPosProstoOption: [],
        loadingPosProstor: true,
        loadingNapUredaji: true
    }

    componentDidMount = async () => {

        const devices = await clientDevices()
        if(!devices.error){              
            this.props.mapState("CLIENT_MAP_DEVICES", devices)
        }

        // get Naplatni Uređaji list
        let listOption = [{label: "Svi", value: "Svi"}]
        this.props.devices.map((data) => (
            listOption.push({label: data.description, value: data.label})
        ))

        this.setState({
            listNapUredOption: listOption,
            loadingNapUredaji: false
        })


        // Get Poslovni Protori
        const businesssPremises = await clientBusinessPremises()

        if(!businesssPremises.error){
            this.props.mapState("CLIENT_MAP_BUSSINES_PREMISES", businesssPremises)
        }

        let propsOption =  [{label: "Svi", value: "Svi"}]
        this.props.businesssPremises.map((data) => (
            propsOption.push({label: data.description, value: data.label})
        ))

        this.setState({
            listPosProstoOption: propsOption,
            loadingPosProstor: false
        })          
       
    }

    //dropdown naplati uređaj
    setNapUredaj = async (data) => {
        this.props.devices.filter(devices => devices.label === data.value).map(filteredData => (
            this.props.mapState("CLIENT_MAP_PICKED_NAP_UREDAJ", filteredData)           
        ))
        if(data.value === "Svi"){
            this.props.mapState("CLIENT_MAP_PICKED_NAP_UREDAJ", {})        
        }
    }


    // dropdown poslovni prostor
    setPosProstor = async (data) => {
        this.props.businesssPremises.filter(devices => devices.label === data.value).map(filteredData => (
            this.props.mapState("CLIENT_MAP_PICKED_POS_PROSTOR", filteredData)
            
            /*this.setState({
                pickedPosProstor : filteredData
            })*/
        ))
        if(data.value === "Svi"){
            this.props.mapState("CLIENT_MAP_PICKED_POS_PROSTOR", {})
        }
    }

    searchInvoices = async () =>{
        const unHashedJwt = await checkJwt()
  
        if(!unHashedJwt){
            logout()
        }      
        
        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", true)
  
        const invoices = await clientInvoices(
            1, 
            this.props.pageSize, 
            this.props.pickedPosProstor, 
            this.props.pickedNapUred,
            this.props.startDate,
            this.props.endDate
        )

        if(!invoices.error){            
            await this.props.mapState("CLIENT_MAP_INVOICES", invoices.data)   
            if(invoices.data.total_number_of_records < 1){
                this.props.mapState("CLIENT_MAP_INVOICES_MESSAGE", "Nema računa")
            } 
        }
        else{
            logout()
            /*
            sessionStorage.clear();
            this.props.mapState("CLIENT_LOG_OUT")
            this.props.history.push("/")
            */
        }

        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", false)
    }

    setStartDate(date){
        this.props.mapState("CLIENT_MAP_START_DATE", date)
        if(date > this.props.endDate){
            this.props.mapState("CLIENT_MAP_END_DATE", date)
        }
    }

    setEndDate(date){
        this.props.mapState("CLIENT_MAP_END_DATE", date)
    }

    render(){
        return(     
            <div style={{border: "2px solid gray", margin: "0px 0px 40px 0px", padding: "20px"}}>

                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-lg-6 col-md-12 col-xs-12">   
                            <div className="form-group row">
                                <label htmlFor="listPosProstoOption" className="col-sm-6 col-form-label">Poslovni prostor</label>
                                <div className="col-sm-6">
                                    {this.state.loadingPosProstor ?
                                    <Dropdown 
                                        disabled
                                        placeholder="Učitavanje..."                                     
                                    />
                                    :
                                    <Dropdown 
                                        isClearable= {true}
                                        placeholder="Svi" 
                                        options={this.state.listPosProstoOption} 
                                        onChange={this.setPosProstor} 
                                        //value={this.state.nazNapUred} 
                                        value={this.props.pickedPosProstor.description ? this.props.pickedPosProstor.description: ""}
                                    />
                                    }
                                </div> 
                            </div>
                            <div className="form-group row">
                                <label htmlFor="listNapUredOption" className="col-sm-6 col-form-label">Naplatni uređaj</label>
                                <div className="col-sm-6">
                                    {this.state.loadingNapUredaji ?
                                    <Dropdown 
                                        disabled
                                        placeholder="Učitavanje..."                                     
                                    />
                                    :
                                    <Dropdown 
                                        placeholder="Svi" 
                                        options={this.state.listNapUredOption} 
                                        onChange={this.setNapUredaj} 
                                        //value={this.state.nazNapUred} 
                                        value={this.props.pickedNapUred.description ? this.props.pickedNapUred.description: ""}
                                    />
                                    }
                                </div> 
                            </div>
                        </div>
                        <div className="col col-sm-12 col-lg-6 col-md-12">   
                            <div className="form-group row">
                                <label htmlFor="datumOd" className="col-sm-6 col-form-label">Datum od</label>
                                <div className="col-sm-6 col-form customDatePickerWidth">                        
                                    <DatePicker
                                        selected={this.props.startDate}
                                        onChange={date => this.setStartDate(date)}
                                        selectsStart
                                        startDate={this.props.startDate}
                                        endDate={this.props.endDate}
                                        locale={hr}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}                                        
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="datumDo" className="col-sm-6 col-form-label">Datum do</label>
                                <div className="col-sm-6 col-form-label customDatePickerWidth"> 
                                    <DatePicker
                                        selected={this.props.endDate}
                                        onChange={date => this.setEndDate(date)}
                                        selectsEnd
                                        startDate={this.props.startDate}
                                        endDate={this.props.endDate}
                                        minDate={this.props.startDate}
                                        locale={hr}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}
                                        stlye={{width: '-webkit-fill-available'}}
                                    />
                                </div> 
                            </div>                                  
                        </div>                
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12 col-form">
                            <div 
                                className="btn btn-light" 
                                style={{float:"right", fontSize: "1.5rem"}} 
                                onClick={this.searchInvoices}
                            >
                                <AiOutlineSearch/> Traži
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        devices : state.client.devices,
        businesssPremises : state.client.businesssPremises,
        pickedPosProstor: state.clientRacuni.pickedPosProstor,
        pickedNapUred: state.clientRacuni.pickedNapUred,
        activePage: state.clientRacuni.activePage,
        pageSize: state.clientRacuni.pageSize,
        startDate: state.clientRacuni.startDate,
        endDate: state.clientRacuni.endDate
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Search);

